

















import Vue from "vue";
import ContactForm from "./ContactForm.vue"; // Adjust the path if necessary

export default Vue.extend({
  name: "Footer",
  components: {
    ContactForm,
  },
});
